var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7427 6.194C11.1107 5.826 11.476 4.96733 9.94265 6.01C7.76399 7.51333 5.61665 8.92467 5.61665 8.92467C5.39561 9.02462 5.15665 9.07886 4.91412 9.08413C4.67159 9.0894 4.43049 9.04559 4.20532 8.95533C3.28532 8.67933 2.21132 8.31133 2.21132 8.31133C2.21132 8.31133 1.47799 7.85067 2.73332 7.36C2.73332 7.36 8.04065 5.182 9.88132 4.41467C10.5867 4.108 12.9793 3.12667 12.9793 3.12667C12.9793 3.12667 14.084 2.69667 13.992 3.74C13.9613 4.16933 13.716 5.67333 13.4707 7.29867C13.102 9.59933 12.7033 12.1153 12.7033 12.1153C12.7033 12.1153 12.642 12.8207 12.1207 12.9433C11.5626 12.9339 11.0234 12.7398 10.5873 12.3913C10.4647 12.2993 8.28665 10.9187 7.48865 10.244C7.40748 10.189 7.34153 10.1144 7.29694 10.0271C7.25236 9.93974 7.23058 9.84256 7.23364 9.74456C7.2367 9.64656 7.2645 9.55093 7.31445 9.46656C7.3644 9.38219 7.43487 9.31182 7.51932 9.262C8.62599 8.25 9.94532 6.992 10.7427 6.194Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.c3b579bf.svg";
export { ForwardRef as ReactComponent };